import create from 'zustand';

const usePaymentModalOpenStore = create((set) => ({
  isPaymentModalOpen: false,
  setIsPaymentModalOpen: (isPaymentModalOpen) => set({ isPaymentModalOpen }),
}));

const setIsPaymentModalOpenSelector = (state) => state.setIsPaymentModalOpen;
const isPaymentModalOpenSelector = (state) => state.isPaymentModalOpen;

export { usePaymentModalOpenStore, setIsPaymentModalOpenSelector, isPaymentModalOpenSelector };
